import EventModalButton from '../ZUILib/EventModalButton/EventModalButton';
import commonUtil from '../../utils/commonUtil';
import React from 'react';

const EventModal = (props) => {
  const mesaDeRegalos = [
    "Crea tu Mesa de Regalos desde nueve meses antes del evento sin costo desde liverpool.com.mx, a través de tu celular o en tu tienda preferida y compártela desde el día uno.",
    "¡Tu primer regalo va por nuestra cuenta!",
    "Recibe 10% de bonificación en monedero electrónico del total de tus compras y regalos.",
    "Elige entre regalos físicos o acumula su valor en monedero electrónico.",
    "Realiza retiros anticipados de tu monedero electrónico para que no falte nada en el cuarto de tu bebé.",
    "Recibe notificaciones por cada regalo que recibas y envía mensajes de agradecimiento."
  ];

  return (
    <div className="modal-overlay">
      <div className="modal-content-event">
        <div className="evnt-modal-header">
          <h4 className="modal-title">{`Beneficios - ${props.event}`}</h4>
          <button className="close-button" onClick={props.closeModal} aria-label="Cerrar modal">
            <img src={commonUtil.getAssetURL() + '/images/close.svg'} alt="" className="icon_vozcliente" />
          </button>
        </div>
        <div className="evnt_modal_body">
          <div className='listDot'>
            <ul>
              {mesaDeRegalos.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
          <div className='hra'> </div>
          <div className='event_modal_sectionTwo'>
            <div className='liststar'>*Acumula $5,000 pesos en regalos o compras personales.</div>
          </div>
          <EventModalButton text={'Crear mi mesa'} route={props.route} />
        </div>
      </div>
    </div>
  );
};

export default EventModal;
